module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-spinner"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa2c25b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 454
// module chunks = 1